module.exports = __webpack_public_path__ + "db5337ce47de677863ba37cbded5d8ed.svg";